import { useState, useEffect } from "react";
import { Container } from "@material-ui/core";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Page from "src/components/Page";
import GateIdea from "src/components/propuesta/GateIdea";
import FormularioPropuestaV2 from "src/components/propuesta/FormularioPropuestaV2";

export default function NuevaPropuestaV2() {
  const navigate = useNavigate();
  const location = useLocation();
  const sucursalAuth = useSelector(
    (state) => state.auth.user?.sucursal?.refSucursal,
  );
  const [gatePasado, setGatePasado] = useState(false);
  const [datosGate, setDatosGate] = useState(null);

  // Salto automático cuando viene migración V1 -> V2 con borrador prearmado
  // en location.state. El borrador se aplica dentro de FormularioPropuestaV2
  // por su propio useEffect; aquí solo hace falta saltar el gate.
  useEffect(() => {
    if (location.state?.borradorMigracion) setGatePasado(true);
  }, [location.state]);

  return (
    <Page title="Nueva propuesta con IA - TAXTIC">
      <Container maxWidth="xl" sx={{ py: 3 }}>
        {!gatePasado ? (
          <GateIdea
            onCompletar={(datos) => {
              setDatosGate(datos);
              setGatePasado(true);
            }}
            onCancelar={() => navigate("/dashboard/propuestas/listar")}
            sucursal={sucursalAuth}
          />
        ) : (
          <FormularioPropuestaV2
            borradorInicialIA={datosGate?.borrador ?? undefined}
            promptOriginalInicial={datosGate?.promptOriginal ?? ""}
            onVolverAlGate={() => setGatePasado(false)}
          />
        )}
      </Container>
    </Page>
  );
}
